//以旧换新管理相关 api
import request from "@/utils/request";
const baseService = "autoapp-default-server-recovery";
// OSS地址
export const OSSUrl = 'https://xlssh.oss-cn-shenzhen.aliyuncs.com/'
// 获取上传签名
export function getSignUp() {
  return request({
    url: `${baseService}/api/OSS/calculatePostSignature`,
    method: "get"
  });
}

// 上传文件和对应文件id到阿里云，形成映射关系
export const upOssSave = data => {
  // return axios.post(`${OSSUrl}`, params)
  return request({
    url: `${OSSUrl}`,
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/file.js